import $ from 'jquery';
import SliderModel from './SliderModel';
import HorizontalSliderView from './HorizontalSliderView';
import VerticalSliderView from './VerticalSliderView';
import AccessoriesSliderView from './AccessoriesSliderView';
import SliderGroupView from './SliderGroup';

export function SliderBuilder($scope) {

    'use strict';

    var selectors = {
        sliderContainer: '.js-slider--container',
        sliderGroup: '.js-slider--group'
    };
    var registeredSliders = [];

    /**
     * Method creates slider view for given element based on provided class
     * @param {$} $element
     * @param {Object} SliderClass
     */
    this.register = function ($element, SliderClass) {

        var config = {
            el: $element,
            model: new SliderModel()
        };

        // noinspection JSValidateTypes
        registeredSliders.push(
            new SliderClass(config)
        );
    };

    /**
     * @return {BaseSliderView[]}
     */
    this.getSliders = function () {
        return registeredSliders;
    };

    this.destroyAll = function () {
        var slider;

        for (var i = 0, len = registeredSliders.length; i < len; i++) { // eslint-disable-line no-restricted-syntax
            /* istanbul ignore else */
            slider = registeredSliders[i];
            slider.undelegateEvents();
            slider.$el.unbind();
        }
        registeredSliders = [];
    };

    /**
     * This method builds sliders for all those that are in DOM
     * @param {Boolean=} force force recreation of all sliders
     */
    this.build = function (force) {

        var $this;
        var context = this;

        if (force === true) {
            this.destroyAll();
        }

        /*
         Iterate over slider containers
         */
        $scope.find(selectors.sliderContainer).each(function () {

            $this = $(this);

            if (force === true || !$this.data('sliderProcesses')) {

                switch ($this.data('sliderType')) {

                    case 'accessories':
                        context.register($this, AccessoriesSliderView);
                        break;

                    case 'series':
                        context.register($this, HorizontalSliderView);
                        break;

                    case 'vertical':
                        context.register($this, VerticalSliderView);
                        break;

                    default:
                        context.register($this, HorizontalSliderView);
                        break;
                }

                /*
                 Mark as processed
                 */
                $this.attr('data-slider-processes', true);
            }
        });

        /*
         Iterate over slider groups
         */
        $scope.find(selectors.sliderGroup).each(function () {
            $this = $(this);
            if (force === true || !$this.data('sliderProcesses')) {
                new SliderGroupView({
                    el: $this,
                    model: null
                });
            }

            /*
             Mark as processed
             */
            $this.attr('data-slider-processes', true);
        });
    };
}

const sliderBuilder = new SliderBuilder($('body'));


export function build(force) {
    sliderBuilder.build(force);
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/sliders/SliderBuilder.js
 **/